import { Component, ChangeDetectionStrategy } from '@angular/core';
import { selectVirtualEventActivity } from 'app/virtual-event/features/activity/activity.selectors';
import { Store, select } from '@ngrx/store';
import { I18nPluralPipe } from '@angular/common';
import { asyncScheduler, Observable } from 'rxjs';
import { selectActivityLayoutHeight } from 'app/core/features/layout.selectors';
import { map, throttleTime } from 'rxjs/operators';

@Component({
  selector: 'app-activity-list',
  templateUrl: './activity-list.component.html',
  styleUrls: ['./activity-list.component.scss'],
  providers: [I18nPluralPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivityListComponent {
  public activities$: Observable<any> = this.store.pipe(
    select(selectVirtualEventActivity),
    throttleTime(1000, asyncScheduler, {
      leading: true,
      trailing: true
    })
  );
  public height$: any = this.store.pipe(
    select(selectActivityLayoutHeight),
    map(height => {
      return height < 164 ? 164: height;
    })
  );

  constructor(
    private store: Store<any>
  ) { }

}
